
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/kaneka",
      function () {
        return require("private-next-pages/cases/kaneka/index.tsx");
      }
    ]);
  